import type { FunctionComponent } from 'react';

import { Skeleton } from '~/ui/core/skeleton/Skeleton';

import {
    ContentContainer,
    ContentSections,
    FlexRowContainer,
    StyledStickyHeader,
    Wrapper,
} from '../../job-architecture-v2';

export const LearningOpportunitySidepanelSkeleton: FunctionComponent = () => (
    <Wrapper data-testid="learning-opportunity-sidepanel-skeleton">
        <StyledStickyHeader>
            <div className="flex w-full items-center justify-between gap-l">
                <div className="flex items-center gap-l">
                    <Skeleton borderRadius="9999px" height="32px" width="32px" />
                    <div className="h-xxl w-px bg-gray-300" />
                    <Skeleton height="24px" width="100px" />
                </div>
                <div className="flex shrink-0 items-center gap-s">
                    <Skeleton height="28px" width="120px" />
                    <Skeleton height="28px" width="80px" />
                </div>
            </div>
        </StyledStickyHeader>
        <div className="flex min-w-full flex-col gap-s">
            <Skeleton height="20px" width="80px" />
            <Skeleton height="32px" width="60%" />
        </div>
        <ContentContainer>
            <div className="flex flex-wrap items-center gap-x-xxl gap-y-s">
                {Array.from({ length: 4 }).map((_, index) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: skeleton items are static placeholders.
                    <Skeleton key={index} height="20px" width="140px" />
                ))}
            </div>
            <div className="flex items-center justify-end gap-s rounded-xl bg-gray-100 p-xxs shadow-sm">
                <Skeleton height="32px" width="80px" />
            </div>
            <FlexRowContainer>
                <ContentSections>
                    <div className="flex flex-col gap-xl">
                        <Skeleton height="20px" width="40%" />
                        <div className="flex flex-col gap-s">
                            <Skeleton height="14px" width="100%" />
                            <Skeleton height="14px" width="95%" />
                            <Skeleton height="14px" width="85%" />
                            <Skeleton height="14px" width="90%" />
                            <Skeleton height="14px" width="70%" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-xl">
                        <div className="flex flex-col gap-m">
                            <Skeleton height="20px" width="40%" />
                            {Array.from({ length: 3 }).map((_, index) => (
                                <div
                                    // biome-ignore lint/suspicious/noArrayIndexKey: skeleton items are static placeholders.
                                    key={index}
                                    className="flex items-center justify-between gap-l py-s"
                                >
                                    <Skeleton height="28px" width="180px" />
                                    <Skeleton height="20px" width="80px" />
                                </div>
                            ))}
                        </div>
                        <div className="flex flex-col gap-m">
                            <Skeleton height="20px" width="30%" />
                            <Skeleton height="20px" width="60%" />
                        </div>
                    </div>
                </ContentSections>
            </FlexRowContainer>
        </ContentContainer>
    </Wrapper>
);
